import li from 'parse-link-header';
import ResponseWrapper from "./ResponseWrapper.mjs";
import { merge } from "./helpers/MergeHeaders.mjs";
import * as Constants from "./Constants.mjs";

function requestAcceptHeaders(sinkMap) {
  return [...sinkMap.keys()].join(', ');
}

export default function (_fetch, _Headers) {
  async function getResponse(effectiveUri, {
    method = 'get',
    headers = {},
    body,
    parsers,
    ...rest
  }) {
    const defaultHeaders = {
      accept: requestAcceptHeaders(parsers)
    };
    const requestInit = {
      method,
      ...filterRequestInit(rest)
    };

    if (method.toLowerCase() !== 'get') {
      requestInit.body = body;
    }

    requestInit.headers = merge(new _Headers(defaultHeaders), new _Headers(headers), _Headers);
    const res = await _fetch(effectiveUri, requestInit);
    const linkHeaders = res.headers.get(Constants.Headers.Link) || '';
    const links = li(linkHeaders) || {};
    let jsonLdContext;

    if (links[Constants.LinkRelations.context]) {
      jsonLdContext = await _fetch(links[Constants.LinkRelations.context].url).then(res => res.json());
    }

    return new ResponseWrapper(effectiveUri, res, parsers, jsonLdContext);
  }

  function resource(uri, requestInit) {
    return getResponse(uri, {
      method: 'get',
      ...requestInit
    });
  }

  function operation(method, uri, requestInit) {
    return getResponse(uri, {
      method,
      ...requestInit
    });
  }

  return {
    resource,
    operation
  };
}

function filterRequestInit(arg = {}) {
  const {
    headers,
    body,
    method,
    redirect,
    ...rest
  } = arg;
  return rest;
}